import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {useApi} from 'src/hooks/useApi';

import {useDispatch, useSelector} from 'react-redux';
import {useInflight} from 'src/hooks/redux';

import * as reduxApi from 'src/utils/redux-api-v2';

import {
  Toast,
  TOAST_SEMANTIC,
  toastApi,
  ToastTitle,
} from '@spaced-out/ui-design-system/lib/components/Toast';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {PanelFooter} from '@spaced-out/ui-design-system/lib/components/Panel';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {
  deleteEvaluationFormDraft,
  getFeedbackConfiguration,
} from 'src/action-creators/crm';
import {selectFeedbackConfiguration} from 'src/selectors/crm';

import EvaluationFormView from './evaluation-form-view';
import EvaluationFormEdit from './evaluation-form-edit';

import css from './evaluation.css';
import useAgencyConfig from 'src/hooks/useAgencyConfig';


const Evaluation = ({
  // @ts-expect-error - TS7031 - Binding element 'review' implicitly has an 'any' type.
  review,
  // @ts-expect-error - TS7031 - Binding element 'onBehalfOfUserId' implicitly has an 'any' type.
  onBehalfOfUserId,
  // @ts-expect-error - TS7031 - Binding element 'scorecard' implicitly has an 'any' type.
  scorecard,
  // @ts-expect-error - TS7031 - Binding element 'sections' implicitly has an 'any' type.
  sections,
  // @ts-expect-error - TS7031 - Binding element 'stepCandidate' implicitly has an 'any' type.
  stepCandidate,
  // @ts-expect-error - TS7031 - Binding element 'step' implicitly has an 'any' type.
  step,
  // @ts-expect-error - TS7031 - Binding element 'onCancel' implicitly has an 'any' type.
  onCancel,
  // redux props
  // @ts-expect-error - TS7031 - Binding element 'scorecardConfigData' implicitly has an 'any' type.
  scorecardConfigData,
  // @ts-expect-error - TS7031 - Binding element 'isViewMode' implicitly has an 'any' type.
  isViewMode,
  // @ts-expect-error - TS7031 - Binding element 'setViewMode' implicitly has an 'any' type.
  setViewMode,
  // @ts-expect-error - TS7031 - Binding element 'updateData' implicitly has an 'any' type.
  updateData,
  // @ts-expect-error - TS7031 - Binding element 'jobId' implicitly has an 'any' type.
  jobId,
}) => {
  const {t} = useLabelTranslation();
  const disableEditDeleteFeedback = useAgencyConfig(
    'disableDeleteEditCandidateFeedback',
  ) as boolean;
  const dispatch = useDispatch();
  const {id: stepId} = step;

  const [submittingReview, setSubmittingReview] = React.useState(false);
  const draftKey = onBehalfOfUserId
    ? `${stepCandidate.id}~${onBehalfOfUserId}`
    : String(stepCandidate.id);
  const {result: jobScorecard} = useApi(
    {pathname: `/job-scorecards/${jobId}`},
    {
      method: 'GET',
      apiPath: '/trmapi/api',
    },
  );

  const {
    result: scorecardStepConfiguration,
    isLoading: isScoreCardConfigDataLoading,
  } = useApi(
    {pathname: `/step-scorecard-config?stepId=${stepId}`},
    {
      method: 'GET',
      apiPath: '/trmapi/api',
    },
  );

  const isFeedbackConfigurationLoading = useInflight(
    getFeedbackConfiguration(),
  );
  const feedbackConfiguration = useSelector(selectFeedbackConfiguration);

  React.useEffect(() => {
    if (!feedbackConfiguration) {
      dispatch(getFeedbackConfiguration());
    }
  }, [jobId, stepId]);

  // @ts-expect-error - TS2339 - Property 'sections' does not exist on type '{}'.
  const {sections: scorecardJobSections = []} = jobScorecard || {};

  const scorecardStepSections = React.useMemo(
    () =>
      scorecardJobSections
        // @ts-expect-error - TS7006 - Parameter 'section' implicitly has an 'any' type.
        .map((section) => {
          // @ts-expect-error - TS2339 - Property 'find' does not exist on type '{}'.
          const foundStepSection = scorecardStepConfiguration?.find(
            (stepSection: any) => stepSection.sectionId === section.id,
          );

          return {
            ...section,
            status: foundStepSection ? foundStepSection.status : '',
          };
        })
        // @ts-expect-error - TS7006 - Parameter 'section' implicitly has an 'any' type.
        .filter((section) => section.status !== 'RESTRICTED'),
    [scorecardJobSections, scorecardStepConfiguration],
  );

  const handleSubmitForm = (evaluation: any) => {
    const {jobId, stageId, stepId, candidateId} = stepCandidate;

    const {hideOverallRecommendation, hideScorecard} = step;

    const newValues = {
      jobId,
      stageId,
      stepId,
      candidateId,
      ...evaluation,
      reviewerId: onBehalfOfUserId,
      interviewCandidateId: stepCandidate.id,
    } as const;

    if (hideScorecard) {
      delete newValues.feedbackScores;
    }
    if (hideOverallRecommendation) {
      delete newValues.reviewStatus;
      delete newValues.comment;
    }

    const apiUrl = review
      ? `api/interview-reviews/${review.id}`
      : 'api/interview-reviews';

    setSubmittingReview(true);

    dispatch(
      reduxApi.post(
        apiUrl,
        {
          ...newValues,
        },
        {},
        {apiPath: '/trmapi/'},
      ),
    )
      .then(() => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.success}>
            <ToastTitle>
              {review
                ? `${t(
                    'Feedback_Updated_Successfully',
                    'Feedback Updated Successfully',
                  )}!`
                : `${t(
                    'Feedback_Added_Successfully',
                    'Feedback Added Successfully',
                  )}!`}
            </ToastTitle>
          </Toast>,
        );
        updateData?.();
        dispatch(deleteEvaluationFormDraft(draftKey));
      })
      .catch((error) => {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {error?.responseBody?.error?.message ??
                t('Feedback_Update_Failed', 'Feedback Update Failed')}
              !
            </ToastTitle>
          </Toast>,
        );
      })
      .finally(() => {
        setSubmittingReview(false);
      });
  };

  if (isFeedbackConfigurationLoading || isScoreCardConfigDataLoading) {
    return <CircularLoader />;
  }

  if (isViewMode && review) {
    return (
      <>
        <div className={css.evaluationFormViewContainer}>
          <EvaluationFormView
            step={step}
            feedbackConfiguration={feedbackConfiguration}
            scorecardStepSections={scorecardStepSections}
            subjectiveSections={sections}
            review={review}
          />
        </div>
        <PanelFooter classNames={{wrapper: css.panelFooterActions}}>
          <Button
            onClick={() => setViewMode(false)}
            type="primary"
            disabled={disableEditDeleteFeedback}
          >
            {t('Edit', 'Edit')}
          </Button>
        </PanelFooter>
      </>
    );
  }

  return (
    // @ts-expect-error - TS2739 - Type '{ step: any; feedbackConfiguration: FEEDBACK_CONFIG_RESPONSE; scorecardStepSections: any; subjectiveSections: any; review: any; stepCandidateId: any; onBehalfOfUserId: any; onSubmit: (evaluation: any) => void; alreadyInPanelBody: boolean; onCancel: any; isSubmitting: boolean; }' is missing the following properties from type '{ scorecardStepSections: any; subjectiveSections: any; feedbackConfiguration: any; review: any; step: any; stepCandidateId: any; token: any; tokenId: any; onBehalfOfUserId: any; alreadyInPanelBody: any; onSubmit: any; onCancel: any; isSubmitting: any; }': token, tokenId
    <EvaluationFormEdit
      step={step}
      feedbackConfiguration={feedbackConfiguration}
      scorecardStepSections={scorecardStepSections}
      subjectiveSections={sections}
      review={review}
      stepCandidateId={stepCandidate.id}
      onBehalfOfUserId={onBehalfOfUserId}
      onSubmit={handleSubmitForm}
      alreadyInPanelBody={true}
      onCancel={onCancel}
      isSubmitting={submittingReview}
    />
  );
};

export default Evaluation;
